import { Injectable } from '@angular/core';
import { HttpService } from '../services/http.service';
import { catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
const ENDPOINT: string = '';
@Injectable({
  providedIn: 'root'
})
export class UserService {
  usuario;
  errorLogin: Observable<any>;
  headerUsuarios: any[] = [
    { field: 'nombre', header: 'Nombre' },
    { field: 'apellido', header: 'Apellido' },
    { field: 'pedidos', header: 'Pedidos' },
    { field: 'debe', header: 'Por Pagar' }
  ];

  constructor(private httpService: HttpService) { }

  getHeadersPedidosGlobales() {
    return this.headerUsuarios;
  }
  getUser() {
    return this.usuario;
  }
  setUser(value) {
    this.usuario = value;
  }
  login(credentials) {
    return this.httpService.post('auth/login', credentials).pipe(catchError(error => { return throwError(error) }));
  }
  sendMail(mail) {
    return this.httpService.post('auth/password', mail);
  }
  userInfo() {
    return this.httpService.get('profile');
  }
  allUsers() {
    return this.httpService.get('usuario/all');
  }
  getUsuariosHabilitados() {
    return this.httpService.get('usuario/habilitados');
  }
  getUsuariosSimpleHabilitados() {
    return this.httpService.get('usuario/simple/habilitados');
  }
  getUsersABM() {
    return this.httpService.get('usuario');
  }
  getUsersBirthday() {
    return this.httpService.get('usuario/birthday');
  }
  newUser(user) {
    return this.httpService.post('usuario', user);
  }
  updateUser(user) {
    return this.httpService.put('usuario/' + user.id, user);
  }
  habilitarUser(user) {
    return this.httpService.put('usuario/habilitar/' + user.id, user);
  }
  deleteUser(userId) {
    return this.httpService.delete('usuario/' + userId);
  }
  getProfile(id) {
    return this.httpService.get('usuario/' + id);
  }
  updatePassword(obj) {
    return this.httpService.post('usuario/password', obj);
  }
  cambiarPassword() {
    try {
      return this.usuario.user.cambiarPassword;
    } catch (e) {
      return false;
    }

  }
}